module.exports = __webpack_public_path__ + "media/images/lb/263-293927710cc04676dc5d405065c0a974.svg";